/**
 * quickFilterStyles - Fonte única do estilo "pill" dos filtros rápidos.
 *
 * Usar nos gatilhos (SelectTrigger / Button outline) das barras de filtro
 * das listagens, Kanbans e dashboards: fundo de superfície, sem borda cinza
 * e cantos arredondados. Não aplicar em campos de formulário comuns.
 *
 * RELEASE: 2026-10-05 v1.0.0 - Criação inicial.
 */
export const QUICK_FILTER_PILL = 'border-0 bg-background rounded-full';
